export const UPDATE_WINDOW_SCROLL_TOP = 'UPDATE_WINDOW_SCROLL_TOP';

export default {
  UPDATE_WINDOW_SCROLL_TOP
};
